import React from "react";
import BAddPage from "../../../components/crud/BAddPage";
import { maklersService } from "../../../service/maklersService";
import { entities } from "../../../utilis/entitiesNames";

export default function MaklersAddPage() {
  return <BAddPage name={entities.BROKERS} service={maklersService} />;
}
